module.exports = require('lodash/sum');
